import React from 'react';
import { Box, Button } from '@heycater/design-system';

function ContentfulButton(props) {
  const { rounded, size, url, target, id, cta } = props;
  return (
    <Box textAlign="center" py={2}>
      <Button rounded={rounded} size={size} href={url} target={target} id={id}>
        {cta}
      </Button>
    </Box>
  );
}

export default ContentfulButton;
